module.exports = __webpack_public_path__ + "bb1e1ad867794c94132fef1490866173.png";


//////////////////
// WEBPACK FOOTER
// ./images/pics2/12.png
// module id = 296
// module chunks = 0